<template>
    <div class="bg-white rounded-xl p-3 mb-3">
        <div class="flex items-center pb-2.5 mb-2.5 border-b border-a-gray-c6c6c6">
            <img class="h-3.5 w-auto" src="@/assets/icon/ic-time.png" alt=""/>
            <div class="ml-2 text-14 text-a-gray-666666">{{ getDateTimeformat(helpchat.createdTime) }}</div>
        </div>
        <div class="text-20 text-a-gray-666666">{{ helpchat.message }}</div>
        <div v-if="helpchat.imageUrl">
            <img :src="helpchat.imageUrl" alt=""/>
        </div>
        <div class="mt-5">
            <div @click="clickOpenComment()"
                 class="text-20 w-full bg-green-1 text-white rounded-full text-center py-1
                 flex items-center justify-center">
                <img class="h-5 w-auto" src="@/assets/icon/ic-comment.png" alt=""/>
                <div class="pt-1 ml-4">ความคิดเห็น ({{helpchat.commentCount}})</div>
            </div>
        </div>
    </div>
</template>
<script>
import DatetimeHelper from "@/helper/DatetimeHelper.js"
export default ({
    name: 'helpchat',
    props: {
        helpchat: { type: Object }
    },
    created: function () {
        console.log("helpchatItem", this.helpchat);
    },
    methods : {
        getDateTimeformat: function (date) {
            return DatetimeHelper.getDatetimeFullFormatNoti(date);
        },
        clickOpenComment: function () {
            this.tracking.event('online_survey', 'click_comment', this.helpchat.userId);
            this.$router.push({ name: 'helpchatComment', params: { id: this.helpchat.buzzKey } })
        }
    }
})
</script>
